import Strings from "@my-dld/assets/strings";
import React from "react";
import { ProcedureDetail } from "@10x/tabu-mobile-api/dist/requests/entity";
import { TabuPropertyType } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { LocaleUtil } from "@eres/core";

export function extractTabuRequestPropertyInfo( procedure: ProcedureDetail ) {
	let label = "";
	let value = "";
	let icon = "land";
	if ( procedure.PropertyInfo && procedure.PropertyInfo.length > 0 ) {
		const property = procedure.PropertyInfo[ 0 ];
		if ( property ) {
			const pType = property.PropertyTypeId;
			switch ( pType as TabuPropertyType ) {
				case TabuPropertyType.LAND:
					icon = "land";
					label = Strings.land_num_label;
					value = property.LandNo;
					if ( property.LandDmNo )
						value += "-" + property.LandDmNo;
					break;
				case TabuPropertyType.VILLA_OR_BUILDING:
					icon = "building";
					label = Strings.building_name;
					value = LocaleUtil.getLocalValue( { ar: property.BuildingNameAr, en: property.BuildingNameEn } );
					break;
				case TabuPropertyType.UNIT:
					icon = "unit";
					label = Strings.Unit_Number_Label;
					value = property.UnitNumber;
					break;
			}
		}
	}
	return { label, value, icon };
}
